// extracted by mini-css-extract-plugin
export default {"CheckboxTextWrapper":"_CheckboxTextWrapper--tuAND","Label":"_Label--PJwXM"};